module.exports = {
    baseurl4: "https://food.goone.club",
    baseurl5: "https://homeservice.goone.club/",
    baseurl6:"https://grocery.goone.club",
     baseurl: "https://api.gosampl.com",
    //  baseurl: "http://192.168.1.14:5432"
}
